import styled from 'styled-components';

import { colorUsage, getSpacing } from 'stylesheetB2c';

import { VIDEO_AREA_Z_INDEX } from '../../Mp3KbpPlayer.style';

export const HIDDEN_CONTROLS_CLASS_NAME = 'hiddenControls';
const BOTTOM_CONTROLS_CONTAINER_HEIGHT = getSpacing(8);
const BOTTOM_CONTROLS_CONTAINER_LATERAL_PADDING = getSpacing(3);
const MOBILE_CONTROLS_Z_INDEX = VIDEO_AREA_Z_INDEX + 1;

export const ControlsWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${MOBILE_CONTROLS_Z_INDEX};
`;
ControlsWrapper.displayName = 'ControlsWrapper';

export const ControlsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  opacity: 1;
  align-items: center;
  justify-content: space-evenly;
  background-color: ${colorUsage.mp3KbpPlayer.controlsBackgroundColor};
  transition: opacity 0.5s;

  /* We need a class to have the correct transition */
  /* stylelint-disable-next-line selector-max-class */
  &.${HIDDEN_CONTROLS_CLASS_NAME} {
    /*
      Setting a transition to display none is impossible in css
      so we use a height 0 with hidden overflow to make the elements
      disappear
      ref: https://stackoverflow.com/questions/3331353/transitions-on-the-css-display-property
    */
    height: 0;
    overflow: hidden;
    opacity: 0;
    transition: opacity 0.5s, height 0s 0.5s;
  }
`;
ControlsContainer.displayName = 'ControlsContainer';

export const BottomControlsContainer = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: ${BOTTOM_CONTROLS_CONTAINER_HEIGHT};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${BOTTOM_CONTROLS_CONTAINER_LATERAL_PADDING};
`;
BottomControlsContainer.displayName = 'BottomControlsContainer';

export const ElapsedAndTotalTimeContainer = styled.div`
  margin-right: ${getSpacing(3)};
`;
ElapsedAndTotalTimeContainer.displayName = 'ElapsedAndTotalTimeContainer';
